import React from "react";

// Plate colours for fast visual reading of the load.
export const PLATE = {
  55: { c: "#8e44ad", h: 100 },
  45: { c: "#2453c4", h: 96 },
  35: { c: "#c9a227", h: 90 },
  25: { c: "#2f9e54", h: 80 },
  10: { c: "#d9dde3", h: 58 },
  5:  { c: "#9c3535", h: 46 },
  2.5:{ c: "#7a8088", h: 36 },
  1.25:{ c: "#454b54", h: 30 },
};

export function solvePlates(target, bar, plateMap) {
  const per = (target - bar) / 2;
  if (per < 0) return { ok: false, perSide: per, plates: [] };
  const denoms = Object.keys(plateMap).filter((d) => plateMap[d]).map(Number).sort((a, b) => b - a);
  const out = [];
  let rem = per;
  for (const d of denoms) { while (rem >= d - 1e-9) { out.push(d); rem = +(rem - d).toFixed(3); } }
  const achieved = bar + (per - rem) * 2;
  return { ok: true, perSide: per, plates: out, achieved, exact: rem < 1e-6 };
}

export default function Barbell({ weight, bar, plateMap, compact }) {
  const sol = solvePlates(weight, bar, plateMap);
  if (!sol.ok) {
    return <div style={{ color: "var(--dim)", fontSize: 13, padding: "6px 0" }}>Below bar weight ({bar} lb)</div>;
  }
  const maxH = compact ? 44 : 76;
  const sleeve = <div style={{ width: compact ? 15 : 20, height: 8, background: "#3a3f48", borderRadius: 2 }} />;
  const plateEl = (d, i, side) => {
    const p = PLATE[d] || { c: "#555", h: 50 };
    const h = (p.h / 100) * maxH;
    return (
      <div key={side + i} title={`${d} lb`} style={{
        width: compact ? 11 : 15, height: h, background: p.c, borderRadius: 2,
        border: "1px solid rgba(0,0,0,.4)", display: "flex", alignItems: "center",
        justifyContent: "center", color: d === 10 ? "#222" : "#fff",
        fontSize: compact ? 0 : 8, fontWeight: 800,
      }}>{!compact && (d < 45 ? d : "")}</div>
    );
  };
  const left = [...sol.plates].reverse();
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, overflowX: "auto", padding: compact ? "2px 0" : "8px 0" }}>
      {left.map((d, i) => plateEl(d, i, "L"))}
      {sleeve}
      <div style={{ width: compact ? 24 : 36, height: 4, background: "linear-gradient(90deg,#5a5f68,#8a8f98,#5a5f68)", borderRadius: 2 }} />
      {sleeve}
      {sol.plates.map((d, i) => plateEl(d, i, "R"))}
    </div>
  );
}
